// source: pbtypes/gen/subject_stream_switcher/zoom_blocker.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.subject_stream_switcher.ZoomBlocker', null, global);
goog.exportSymbol('proto.subject_stream_switcher.ZoomBlocker.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.subject_stream_switcher.ZoomBlocker = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.subject_stream_switcher.ZoomBlocker, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.subject_stream_switcher.ZoomBlocker.displayName = 'proto.subject_stream_switcher.ZoomBlocker';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.subject_stream_switcher.ZoomBlocker.prototype.toObject = function(opt_includeInstance) {
  return proto.subject_stream_switcher.ZoomBlocker.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subject_stream_switcher.ZoomBlocker} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.subject_stream_switcher.ZoomBlocker.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subject_stream_switcher.ZoomBlocker}
 */
proto.subject_stream_switcher.ZoomBlocker.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.subject_stream_switcher.ZoomBlocker;
  return proto.subject_stream_switcher.ZoomBlocker.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subject_stream_switcher.ZoomBlocker} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subject_stream_switcher.ZoomBlocker}
 */
proto.subject_stream_switcher.ZoomBlocker.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.subject_stream_switcher.ZoomBlocker.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.subject_stream_switcher.ZoomBlocker.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subject_stream_switcher.ZoomBlocker} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.subject_stream_switcher.ZoomBlocker.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.subject_stream_switcher.ZoomBlocker.Enum = {
  INCOMPATIBLE_ISP_CONFIGURATION: 0,
  ACTIVE_SUBJECT_TRACK: 1,
  SYSTEM_IN_TRANSITION: 2,
  INCOMPATIBLE_FLIGHT_STATE: 3,
  DIGITAL_ZOOM_NOT_ENABLED: 4,
  EQUIRECT_NOT_ENABLED: 5,
  SKILL_TRACKING_ENABLED: 6,
  SKILL_BLOCKED: 7,
  SKILL_BLOCKED_IR_ONLY: 8
};

goog.object.extend(exports, proto.subject_stream_switcher);
